var exports = {
  "x3": "xaee3c4fa--ef4845--list-item",
  "G3": "xaee3c4fa--ef4845--list-item__content",
  "aO": "xaee3c4fa--ef4845--list-item__content-full",
  "TB": "xaee3c4fa--ef4845--list-item__link_img",
  "Pj": "xaee3c4fa--ef4845--list-item__category",
  "XA": "xaee3c4fa--ef4845--list-item__category-container",
  "jd": "xaee3c4fa--ef4845--list-item__category-empty",
  "_F": "xaee3c4fa--ef4845--list-item__ads-caption",
  "zH": "xaee3c4fa--ef4845--list-item__title",
  "lI": "xaee3c4fa--ef4845--list-item__link",
  "gX": "xaee3c4fa--ef4845--list-item__description-wrap",
  "xq": "xaee3c4fa--ef4845--list-item__description",
  "_I": "xaee3c4fa--ef4845--list-item__img",
  "p6": "xaee3c4fa--ef4845--list-item__img-mobile",
  "Qs": "xaee3c4fa--ef4845--list-item__link_img-visited",
  "Tf": "xaee3c4fa--ef4845--list-item__link_category-visited",
  "MK": "xaee3c4fa--ef4845--list-item__link-visited",
  "eh": "xaee3c4fa--ef4845--list-item__title-hover",
  "lo": "xaee3c4fa--ef4845--views-icon",
  "xV": "xaee3c4fa--ef4845--comments-icon",
  "Zv": "xaee3c4fa--ef4845--list-item__comments",
  "H1": "xaee3c4fa--ef4845--list-item__views",
  "Tt": "xaee3c4fa--ef4845--list-item__date",
  "CL": "xaee3c4fa--ef4845--post-info",
  "ag": "xaee3c4fa--ef4845--post-info_author",
  "$X": "xaee3c4fa--ef4845--post-info_author__name",
};

module.exports = exports;
